import * as Menu from "@radix-ui/react-dropdown-menu";
import type { ComponentProps } from "react";
import { cn } from "../lib/cn";

export const DropdownMenu = Menu.Root;
export const DropdownMenuTrigger = Menu.Trigger;
export const DropdownMenuGroup = Menu.Group;
export const DropdownMenuRadioGroup = Menu.RadioGroup;

export function DropdownMenuContent({
  className,
  sideOffset = 4,
  align = "start",
  ...rest
}: ComponentProps<typeof Menu.Content>) {
  return (
    <Menu.Portal>
      <Menu.Content
        sideOffset={sideOffset}
        align={align}
        className={cn(
          "z-50 min-w-48 rounded-lg border border-line bg-surface p-1 text-fg shadow-pop outline-none animate-fade-in motion-reduce:animate-none",
          className,
        )}
        {...rest}
      />
    </Menu.Portal>
  );
}

const ITEM_CLASS =
  "flex cursor-pointer select-none items-center gap-2 rounded-md px-2.5 py-2 text-sm outline-none data-[highlighted]:bg-sunken data-[disabled]:pointer-events-none data-[disabled]:opacity-50";

export interface DropdownMenuItemProps extends ComponentProps<typeof Menu.Item> {
  tone?: "default" | "danger";
}

export function DropdownMenuItem({ className, tone = "default", ...rest }: DropdownMenuItemProps) {
  return (
    <Menu.Item
      className={cn(ITEM_CLASS, tone === "danger" && "text-danger data-[highlighted]:bg-danger-soft", className)}
      {...rest}
    />
  );
}

export function DropdownMenuRadioItem({ className, ...rest }: ComponentProps<typeof Menu.RadioItem>) {
  return <Menu.RadioItem className={cn(ITEM_CLASS, "data-[state=checked]:bg-primary-soft", className)} {...rest} />;
}

export const DropdownMenuItemIndicator = Menu.ItemIndicator;

export function DropdownMenuLabel({ className, ...rest }: ComponentProps<typeof Menu.Label>) {
  return (
    <Menu.Label
      className={cn("px-2.5 py-1.5 text-[10px] font-bold uppercase tracking-wider text-fg-subtle", className)}
      {...rest}
    />
  );
}

export function DropdownMenuSeparator({ className, ...rest }: ComponentProps<typeof Menu.Separator>) {
  return <Menu.Separator className={cn("divider my-1", className)} {...rest} />;
}
